var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49999 0C6.62201 0.00206238 4.82153 0.749002 3.49359 2.07694C2.16566 3.40487 1.41872 5.20535 1.41666 7.08333C1.41666 10.8248 7.36666 15.9609 8.04241 16.5346L8.49999 16.9214L8.95757 16.5346C9.63332 15.9609 15.5833 10.8248 15.5833 7.08333C15.5813 5.20535 14.8343 3.40487 13.5064 2.07694C12.1784 0.749002 10.378 0.00206238 8.49999 0ZM8.49999 10.625C7.79951 10.625 7.11477 10.4173 6.53235 10.0281C5.94992 9.63896 5.49598 9.08583 5.22792 8.43867C4.95986 7.79152 4.88972 7.0794 5.02638 6.39239C5.16303 5.70537 5.50034 5.07431 5.99565 4.579C6.49096 4.08369 7.12203 3.74638 7.80905 3.60972C8.49606 3.47306 9.20817 3.5432 9.85533 3.81126C10.5025 4.07932 11.0556 4.53327 11.4448 5.11569C11.8339 5.69811 12.0417 6.38286 12.0417 7.08333C12.0405 8.0223 11.667 8.92248 11.0031 9.58643C10.3391 10.2504 9.43895 10.6239 8.49999 10.625Z",
    fill: "#EE4E56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9.20898C9.6736 9.20898 10.625 8.25759 10.625 7.08398C10.625 5.91038 9.6736 4.95898 8.5 4.95898C7.32639 4.95898 6.375 5.91038 6.375 7.08398C6.375 8.25759 7.32639 9.20898 8.5 9.20898Z",
    fill: "#EE4E56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker1);
export default __webpack_public_path__ + "static/media/marker1.629221e4aeb4e3c53a6d73739189acc6.svg";
export { ForwardRef as ReactComponent };